var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 0h20v20H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1FADFF",
    fillRule: "nonzero",
    d: "M14.999 2H1.001C.113 2-.335 3.078.294 3.707L6 9.414v5.836a1 1 0 00.341.753l2 1.75c.64.558 1.659.114 1.659-.754V9.414l5.706-5.707C16.334 3.08 15.89 2 15 2zM9 9v8l-2-1.75V9L1 3h14L9 9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1FADFF",
    strokeLinecap: "square",
    d: "M15.303 14.803L1.248.748"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE2IDE4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTS0yIDBoMjB2MjBILTJ6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iIzFGQURGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTQuOTk5IDJIMS4wMDFDLjExMyAyLS4zMzUgMy4wNzguMjk0IDMuNzA3TDYgOS40MTR2NS44MzZhMSAxIDAgMCAwIC4zNDEuNzUzbDIgMS43NWMuNjQuNTU4IDEuNjU5LjExNCAxLjY1OS0uNzU0VjkuNDE0bDUuNzA2LTUuNzA3QzE2LjMzNCAzLjA4IDE1Ljg5IDIgMTUgMnpNOSA5djhsLTItMS43NVY5TDEgM2gxNEw5IDl6Ii8+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjMUZBREZGIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBkPSJNMTUuMzAzIDE0LjgwM0wxLjI0OC43NDgiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgFilterBan as ReactComponent };